import { Controller } from "@hotwired/stimulus";
import mapboxgl from "mapbox-gl";

export default class extends Controller {
  static values = {
    token: String,
    center: Array,
    locations: Array,
    markerImagePath: String,
  };

  static targets = ["map"];

  connect() {
    mapboxgl.accessToken = this.tokenValue;
    this.initMap();
    this._json = this.locationsValue;
    this._map.on("load", this.addMarkers.bind(this));
  }

  initMap() {
    this._map = new mapboxgl.Map({
      container: this.mapTarget.getAttribute("id"),
      style: "mapbox://styles/mapbox/streets-v11",
      center: this.centerValue || [26.1025, 44.4268],
      zoom: 6,
    });

  }

  addMarkers() {
    this._json.forEach((location) => {
      const el = document.createElement("div");
      console.log(el)
      el.className = "marker";
      el.classList.add("bg-cover", "w-[40px]", "h-[45px]", "cursor-pointer", "bg-[url('pin.png')]");
      const popup = new mapboxgl.Popup({ offset: 25 })
        .setHTML(`
          <div class="du-card w-96 relative du-card-xs bg-primary/15 shadow-xl p-3">
            <div class="absolute left-3 -top-4 w-fit">
              <div class="bg-primary p-1 px-2 rounded-lg">
                <div class="text-white">${location.project.priority}</div>
              </div>
              <div class="text-left pt-1 text-neutral">${location.project.start_date}</div>
            </div>
              <div class="du-card-body text-center">
                <h2 class="mt-3 tracking-tight line-clamp-3">${location.project.name}</h2>
                <div class="text-base text-black/70 mt-3"> ${location.project.recipient}</div>
                <div class="w-1/12 mx-auto my-3 border-t border-neutral"></div>
                <div class="text-sm text-neutral">Valoare totală proiect</div>
                <div class="font-bold text-2xl">${location.project.total_amount}</div>
              </div>
                <a href="${location.project.slug}" class="absolute inset-0">
                </a>
            </div>
          </div>
        `);

      popup.on('open', () => {
        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupContentButton = document.querySelector('.mapboxgl-popup-close-button');
        if (popupContent) {
          popupContent.style.padding = '0';
          popupContent.style.width = '24rem';
          popupContentButton.style.display = 'none';
        }
      });

      new mapboxgl.Marker(el)
        .setLngLat([location.location.long, location.location.lat])
        .setPopup(popup)
        .addTo(this._map);
    });

    if (this._json.length > 0) {
      this._map.setCenter([this._json[0].location.long, this._json[0].location.lat]);
      this._map.setZoom(10);
    }
  }

}
